export default __webpack_public_path__ + "static/media/director-signature-2.5d588b86.png";